module.exports = __webpack_public_path__ + "img/ic_email.09112672.png";